import { render, staticRenderFns } from "./ReturnComponent.vue?vue&type=template&id=1e0ac99e&scoped=true&"
import script from "./ReturnComponent.vue?vue&type=script&lang=js&"
export * from "./ReturnComponent.vue?vue&type=script&lang=js&"
import style0 from "./ReturnComponent.vue?vue&type=style&index=0&id=1e0ac99e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0ac99e",
  null
  
)

export default component.exports